module.exports = __webpack_public_path__ + "media/pdfs/headlight_terms-10d59990512ae0d6d2013975321705b3.pdf";